import { useQuery, ApolloQueryResult } from '@apollo/client';

import { LearningCollectionDocument } from '@/store/v2';
import { LearningCollection } from '@/types/learning/learning-catalog';
import { LearningVisibility } from '@/types/learning';
import { HookResult } from './apolloClient';

export interface CollectionInputItem {
  productId?: number;
  learningId?: number;
  order: number;
  visibility: LearningVisibility;
}

interface LearningCollectionResponse extends HookResult {
  learningCollection: Readonly<LearningCollection> | null;
  refetch: (variables?: { id?: number }) => Promise<ApolloQueryResult<{ learningCollection: LearningCollection }>>;
}

export const useLearningCollection = (id: number): LearningCollectionResponse => {
  const { data, error, refetch, networkStatus, loading } = useQuery<{ learningCollection: Readonly<LearningCollection> }>(
    LearningCollectionDocument,
    {
      skip: !id,
      variables: { id },
    },
  );
  const learningCollection = (data && data.learningCollection) || null;

  return {
    learningCollection,
    error,
    refetch,
    networkStatus,
    loading,
  };
};
